/*
 * SmartFi color tokens.
 *
 * Surface / text / border tokens route through CSS variables so the whole
 * dashboard can live-switch between light and dark mode (see ThemeProvider +
 * GlobalStyles). Brand colors (PRIMARY, SUCCESS, etc.) stay as plain hex so
 * existing hex-alpha math like `${colors.PRIMARY}20` keeps working.
 */
export const colors = {
   // ——— Brand / accent ———————————————————————————————
   PRIMARY: '#3760F9',
   SECONDARY: '#D2FD58',

   PRIMARY90: '#627AFF',
   PRIMARY70: '#8795FF',
   PRIMARY50: '#A9B2FF',
   PRIMARY20: '#CACFFF',

   SECONDARY90: '#9BC81A',
   SECONDARY70: '#669500',
   SECONDARY50: '#336500',
   SECONDARY20: '#173700',

   BLUE: '#0d6efd',
   BLUE_LIGHT: '#3883f5',
   BLUE_SUPER_LIGHT: 'var(--app-brand-tint)',
   INDIGO: '#6610f2',
   PURPLE: '#6f42c1',
   PINK: '#d63384',
   RED: '#dc3545',
   ORANGE: '#fd7e14',
   YELLOW: '#ffc107',
   GREEN: '#198754',
   GREEN_APPLE: '#00bb19',
   TEAL: '#20c997',
   CYAN: '#0dcaf0',
   GRAY: '#6c757d',
   SUCCESS: '#198754',
   SUCCESS_LIGHT: '#aee9d1',
   INFO: '#0dcaf0',
   WARNING: '#ffc107',
   WARNING_LIGHT: '#fdd55b',
   DANGER: '#dc3545',
   LIGHT: '#f8f9fa',
   DARK: '#212529',

   // ——— Theme-aware surface / text / border tokens ————————
   WHITE: 'var(--app-surface)',
   MAIN_DARK: 'var(--app-text)',
   MAIN_DARK90: 'var(--app-text)',
   MAIN_DARK70: 'var(--app-text-dim)',
   MAIN_DARK50: 'var(--app-text-muted)',
   MAIN_DARK20: 'var(--app-border-strong)',

   GRAY_DARK: 'var(--app-text)',
   GRAY1: 'var(--app-text-dim)',
   GRAY2: 'var(--app-text-dim)',
   GRAY3: 'var(--app-text-muted)',
   GRAY4: 'var(--app-text-muted)',
   GRAY5: 'var(--app-text-muted)',
   GRAY6: 'var(--app-text-soft)',
   GRAY7: 'var(--app-text-soft)',
   GRAY8: 'var(--app-text-soft)',
   GRAY9: 'var(--app-border-strong)',
   GRAY10: 'var(--app-border-strong)',
   GRAY11: 'var(--app-border)',
   GRAY12: 'var(--app-border)',
   GRAY13: 'var(--app-border)',
   GRAY14: 'var(--app-surface-muted)',

   BOXSHADOW: '0 2px 8px var(--app-shadow)',
} as const;

export type ColorsType = keyof typeof colors;
